import moment from 'moment';
import { getGlobalProps } from '../utils/queryHelpers';
import {
  DEFAULT_SHIPMENT_MODE,
  DEFAULT_SHIPMENT_DIRECTION,
  DEFAULT_UNIT_PACKAGE_TYPE,
  DEFAULT_SHIPMENT_UNIT_COUNT,
  DEFAULT_SHIPMENT_ITEM_COUNT
} from '../constants/constants';
// model for blank shipment

export const getShipmentModel = () => {
  const {
    orgInfo: {
      config: {
        defaultDimensionUnit = '',
        defaultWeightUnit = '',
        defaultCountry
      }
    }
  } = getGlobalProps();
  return {
    id: null,
    references: [],
    requestedServices: [],
    requestedEquipment: [],
    orgId: '',
    businessId: '',
    divisionId: '',
    proNumber: '',
    totalLinearFeet: null,
    glCodeId: null,
    bolNumber: '',
    shipmentModeId: DEFAULT_SHIPMENT_MODE,
    shipmentStatusId: '',
    shipmentDirectionId: DEFAULT_SHIPMENT_DIRECTION,
    bolInstructions: '',
    carrierPickupNumber: '',
    shipperPickupNumber: '',
    selectedShipmentRate: {},
    shipmentRates: [],
    lcpExceptionReasonId: null,
    lcpExceptionReasonNotes: null,
    rateListGuid: null,
    rateItemGuid: null,
    billToInfo: {
      billTo: null,
      companyName: null,
      billToAddress: {
        address1: null,
        address2: null,
        postalCode: null,
        city: null,
        state: null,
        country: null
      },
      billToContactInfo: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null
      }
    },
    changedUtc: null,
    changedByUser: {
      firstName: '',
      lastName: '',
      loginEmail: ''
    },
    createdUtc: null,
    createdByUser: {
      firstName: '',
      lastName: '',
      loginEmail: ''
    },
    externalId: '',
    stops: [
      {
        // Initialize with today's date.
        // This is the same format as the datepicker
        // To/From Time of day for a new shipment will be automatically set on the server
        //   as long as the date is passed as midnight
        plannedToTimeLocal: moment().format('YYYY/MM/DD'),
        locationAddress: {
          country: defaultCountry,
          address1: null,
          address2: null,
          city: null,
          state: null,
          postalCode: null
        }
      },
      {
        locationAddress: {
          country: defaultCountry,
          address1: null,
          address2: null,
          city: null,
          state: null,
          postalCode: null
        }
      }
    ],
    handlingUnits: [
      {
        doNotStack: false,
        stackable: true,
        pickupStopNumber: 0,
        deliveryStopNumber: 1,
        unitCount: DEFAULT_SHIPMENT_UNIT_COUNT,
        dimensionInfo: {
          length: 0,
          width: 0,
          height: 0,
          dimensionUnit: defaultDimensionUnit
        },
        packageTypeId: DEFAULT_UNIT_PACKAGE_TYPE,
        actualWeightInfo: {
          weight: 0,
          weightUnit: defaultWeightUnit
        },
        freightInfo: {
          freightClassId: ''
        },
        shipmentItems: [
          {
            quantity: DEFAULT_SHIPMENT_ITEM_COUNT,
            product: {
              name: '',
              description: '',
              pieceCount: 1,
              packageTypeId: '',
              isHazMat: false,
              valueInfo: {
                value: null
              },
              freightInfo: {
                freightClassId: '',
                nmfcSubCode: '',
                nmfcItemCode: ''
              },
              hazMat: {
                properShippingName: '',
                unNumber: '',
                comments: '',
                contactFirstName: '',
                contactLastName: ''
              },
              weightInfo: {
                weight: '',
                weightUnit: defaultWeightUnit
              }
            }
          }
        ]
      }
    ],
    notes: []
  };
};

export default getShipmentModel;
